import React, { useRef, useState } from "react";
import ExportReportList from "../AccessibleDropdown/ExportReportList";
import { exportDataMenu } from "../../utils/constants";
import loaderGIF from "../../assets/images/gifs/loaderGIF.gif";
const ExtractBar = ({ title, extractExcel, extractPdf, isTitle = true }) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const itemRefs = useRef([]);

  // const ExtractDataContent = () => {
  //   return (
  //     <div className="extract_data_container downloadPdf" tabIndex={-1}>
  //       <p className="export_data_text">Export Data</p>
  //       <div className="listitem_container">
  //         <button
  //           className="list-data"
  //           role="menuitem"
  //           onClick={() => {
  //             extractExcel();
  //             setOpen(false);
  //           }}
  //         >
  //           <div className="listitem_icon excel"></div>
  //           <div>Export to Excel</div>
  //         </button>
  //         <button
  //           className="list-data"
  //           role="menuitem"
  //           onClick={async () => {
  //             if (isDownloading) return; // guard against double-click while already running
  //             setIsDownloading(true);
  //             try {
  //               await extractPdf();
  //             } finally {
  //               setIsDownloading(false);
  //               setOpen(false);
  //             }
  //           }}
  //         >
  //           <div className="listitem_icon pdf"></div> <div>Export to PDF</div>
  //         </button>
  //       </div>
  //       {isDownloading && (
  //         <div className="popup_downloader">
  //           <img src={loaderGIF} alt="img" />
  //         </div>
  //       )}
  //     </div>
  //   );
  // };
  return (
    <div className="summary_title_bar">
      {isTitle && <h2 className="summary_title">{title}</h2>}

      {/* <PopupMenuData
          ariaControls={"export-menu"}
          ariaId={"export-btn"}
          ariaHasPopUp="menu"
          open={open}
          setOpen={setOpen}
          buttonElement={<ExtractButton ariaHidden={true} tabIndex={-1} />}
          popupClassName={{ open: "clicked-hover", close: "" }}
        >
          <ExtractDataContent />
        </PopupMenuData> */}

      <ExportReportList
        exportExcel={extractExcel}
        exportPdf={async () => {
          if (isDownloading) return; // guard against double-click while already running
          setIsDownloading(true);
          try {
            await extractPdf();
          } finally {
            setIsDownloading(false);
            //setOpen(false);
          }
        }}
        buttonProps={{ buttonType: "normalExport", title: "Extract Data" }}
        popupClassName={{
          open: "clicked-hover",
          close: "",
          wrapperClass: "popup_menu_container",
          containerClass: "downloadPdf",
        }}
        restrictHover={true}
        itemRefs={itemRefs}
        menuItems={exportDataMenu}
        accessibilityValues={{
          buttonId: "export-dropdown",
          ariaHaspopup: "menu",
          ariaControls: "extract-menu",
          ariaLabel: "Extract Data",
        }}
      >
        <>
          {isDownloading && (
            <div className="popup_downloader">
              <img src={loaderGIF} alt="img" />
            </div>
          )}
        </>
      </ExportReportList>
    </div>
  );
};

export default ExtractBar;
